
import React from "react";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { WorksheetManagementTable } from "@/components/admin/worksheet/WorksheetManagementTable";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { FileSpreadsheet } from "lucide-react";

const AdminWorksheetManagementPage: React.FC = () => {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <SidebarInset>
          <div className="container mx-auto px-4 py-8">
            <h1 className="text-2xl font-bold mb-6">จัดการชีทการสอน</h1>
            
            <Alert className="mb-4">
              <FileSpreadsheet className="h-4 w-4" />
              <AlertDescription>
                คุณสามารถค้นหา กรอง และเรียงลำดับชีทการสอนทั้งหมดได้ที่นี่ และสามารถแก้ไขข้อมูลได้โดยคลิกที่ปุ่มแก้ไข
              </AlertDescription>
            </Alert>
            
            <WorksheetManagementTable />
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default AdminWorksheetManagementPage;
